import { render, staticRenderFns } from "./Jobagree.vue?vue&type=template&id=651bfc7d&"
import script from "./Jobagree.vue?vue&type=script&lang=js&"
export * from "./Jobagree.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/agree_reset.css?vue&type=style&index=0&lang=css&"
import style1 from "@/assets/css/agree_stylesheet.css?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports